import { Component, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AlertDialogData } from '../../../types';

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
})
export class AlertDialogComponent {
  @Input() data!: AlertDialogData;

  constructor(protected bsModalRef: BsModalRef) {}

  get hasTitle(): boolean {
    return String(this.data.title || '').length > 0;
  }

  get title(): string {
    return this.data.title as string;
  }

  get message(): string {
    return this.data.message as string;
  }
}
